import React, { useState, useEffect } from 'react';
import { SourceUnits, fnMillisecondsToStr, manageTimeSourceUnits } from '../../../services/shared';
import { Tooltip } from '@mui/material';
import { Typography } from 'antd';

interface ElapsedTimeProps {
    timestamp: number | Date | string;  // This is the JavaScript timestamp (in seconds)
    sourceUnits?: SourceUnits | 'date'
    tooltipActualValue?:boolean
    showTimeDirection?: [string,string]
}

const ElapsedTime: React.FC<ElapsedTimeProps> = ({ timestamp, sourceUnits, tooltipActualValue, showTimeDirection= ['ago','from now'] }) => {
    let initialCompareMS=0
    if (sourceUnits == 'date') {
        if (typeof(timestamp)=='string') {
            const parsedDate = new Date(timestamp);
            initialCompareMS = parsedDate.getTime();
        }
        else if (typeof(timestamp)!='number') {
            initialCompareMS =  timestamp.getTime()
        } else {
            return
        }
    }
    else {
        if (typeof(timestamp)!='number') return
        initialCompareMS = manageTimeSourceUnits(timestamp,sourceUnits);
    }
    const initialDifference = Date.now()-initialCompareMS
    const [elapsedTime, setElapsedTime] = useState<number>(initialDifference);
    const [timeDirection, setTimeDirection] = useState<string>(showTimeDirection[0]);

    useEffect(() => {
        // console.log(showTimeDirection)
        const interval = setInterval(() => {
            const now = Date.now();
            const difference = now - initialCompareMS;
            // console.log(now,difference,timestamp,sourceUnits)
            if (difference<0) {
                setTimeDirection(showTimeDirection[1])
                setElapsedTime(difference*-1);
            } else {
                setElapsedTime(difference);
            }
        }, 1000);

        // Clear interval on component unmount
        return () => clearInterval(interval);
    }, [timestamp]);

    const formattedElapsedTime = fnMillisecondsToStr(elapsedTime);
    const actualComponent = (<span style={{ cursor: 'default' }}>
                                {formattedElapsedTime} {timeDirection}
                            </span>)

    return tooltipActualValue ? (
        <Tooltip title={sourceUnits == 'date' ? <Typography>timestamp</Typography> : new Date(Number(timestamp) * (sourceUnits === 'ms' ? 1 : 1000)).toLocaleString()}>
          {actualComponent}
        </Tooltip>
      ) : actualComponent;  
}

export default ElapsedTime;
